"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _serializeForm = _interopRequireDefault(require("../_utils/serializeForm"));

var _context = _interopRequireWildcard(require("./context"));

var _Item = _interopRequireDefault(require("./Item"));

var _Field = _interopRequireDefault(require("./Field"));

var _Actions = _interopRequireDefault(require("./Actions"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Form = function (_React$Component) {
  (0, _inherits2.default)(Form, _React$Component);

  var _super = _createSuper(Form);

  function Form(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Form);
    _this = _super.call(this, props);

    _this.handleSubmit = function (e) {
      var data = _this.serialize();

      if (data === null || !_this.props.onSubmit) {
        return;
      }

      _this.props.onSubmit(e, data);
    };

    _this._attachRef = function ($$form) {
      _this.formRef.current = $$form;

      if (_this.props.innerRef) {
        if (typeof _this.props.innerRef === 'function') {
          _this.props.innerRef($$form);
        } else {
          _this.props.innerRef.current = $$form;
        }
      }
    };

    _this.formRef = React.createRef();
    return _this;
  }

  (0, _createClass2.default)(Form, [{
    key: "elements",
    get: function get() {
      var $$form = this.formRef.current;

      if (!$$form) {
        return null;
      }

      return $$form.elements;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var $$form = this.formRef.current;

      if (!$$form) {
        return null;
      }

      return (0, _serializeForm.default)($$form);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          layout = _this$props.layout;

      var context = _objectSpread(_objectSpread({}, _context.DEFAULT_CONTEXT), {}, {
        vertical: layout === 'vertical'
      });

      var _className = (0, _classnames.default)(className, 'Form');

      return React.createElement(_context.default.Provider, {
        value: context
      }, React.createElement("form", {
        ref: this._attachRef,
        className: _className,
        onSubmit: this.handleSubmit,
        noValidate: true
      }, children));
    }
  }]);
  return Form;
}(React.Component);

Form.Item = _Item.default;
Form.Field = _Field.default;
Form.Actions = _Actions.default;
Form.defaultProps = {
  onSubmit: function onSubmit(e) {
    e.preventDefault();
  },
  layout: 'horizontal',
  innerRef: undefined,
  className: undefined
};
var _default = Form;
exports.default = _default;